/**
 * Build a tenant's public booking URL for a form identifier (slug or GUID),
 * e.g. `https://{subdomain}.routemize.com/e/{identifier}`.
 *
 * Uses the current window origin and swaps in the tenant subdomain when known
 * (important when the caller isn't already on the tenant's subdomain — e.g. an
 * admin impersonating). The identifier is the value stored on
 * CompanySettings.DefaultRoutemizeLink (slug if configured, else the form GUID).
 */
export function buildPublicBookingUrl(identifier: string, subdomain?: string | null): string {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port ? `:${window.location.port}` : '';
  if (subdomain) {
    const baseDomain = hostname.replace(/^[^.]+\./, '');
    return `${protocol}//${subdomain}.${baseDomain}${port}/e/${identifier}`;
  }
  return `${protocol}//${hostname}${port}/e/${identifier}`;
}
